module.exports = __webpack_public_path__ + "media/images/icons/dzen-e96e16c505974040c4d03e61fc321393.svg";